import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ReportData {
  reportId: number | null;
  report_name: string | null;
  job_data: any; // you can replace `any` with a proper job data type if available
  report_date: string | null;
  report_format: "pdf" | "slides" | string; // or just string if more formats are possible
  templateId: number | null;
  job: any; // you can replace `any` with a proper job type if available
  templateName: string;
  report_link: string;
  cover_image: File | null;
  logo_image: File | null;
  cover_image_url: string | null;
  partner_logo_url?: string | null;
  logo_image_url: string | null;
  search_log_id?: number | string | null;
  report_content_generated?: boolean;
}

interface ReportState {
  report_candidates: any;
  selected_candidate: any;
  selectedCandidate: any | null;
  template: any | null;
  subStepName: string | null;
  reportData: ReportData;
  data: any;
  actions_allowed: any;
}

export const initialReportData: ReportData = {
  reportId: null,
  report_name: null,
  job_data: null,
  report_date: null,
  search_log_id: null,
  report_format: "slides",
  templateId: null,
  job: null,
  templateName: "DefaultTemplate",
  report_link: "",
  cover_image: null,
  logo_image: null,
  cover_image_url: "https://storage.googleapis.com/webapp-static-dev/report_templates/covers/Bitmap.jpg",
  partner_logo_url: null,
  logo_image_url: "https://storage.googleapis.com/webapp-static-dev/report_templates/logos/GB_sinecure_pale_1.png",
  report_content_generated: false,
};


export const templateSteps = [
  "selectReportType",
  "selectTemplate",
  // "introPage",
  "pageConfig",
  "uploadCompanyDetails",
  "candidateListPage",
  "enabledPages",
  "addContent",
];


export const initialTemplate = [
  {
    stepName: "uploadCompanyDetails",
    label: "Company Details",
    settings: {
      companyName: null,
    },
    enabled: true
  },
  {
    stepName: "introPage",
    label: "Slide Content",
    settings: {
      partnerLogo: null,
      reportTitle: null,
      clientLogo: null,
      date: null,
      footerText: null,
      preparedBy: null,
    },
    enabled: true
  },
  {
    stepName: "pageConfig",
    label: "Page Configuration",
    settings: {
      mainHeading: "Contents",
      customLogo: null,

      background: null,
      config: [
        {
          label: "Cover Page",
          subLabel: "Cover Page",
          value: "uploadCompanyDetails",
          enabled: true,
          showLogo: true,
        },
        {
          label: "Intro Page",
          subLabel: "Intro Page",
          value: "introPage",
          enabled: true,
          showLogo: true,
        },

        {
          label: "Content",
          subLabel: "Content",
          value: "pageConfig",
          enabled: true

        },
        {
          label: "Privacy statement",
          subLabel: "Privacy statement",
          value: "addPrivacyStatement",
          enabled: true
        },
        {
          label: "Brief in essence",
          subLabel: "Brief in essence",
          value: "addBriefInEssence",
          enabled: true

        },
        {
          label: "Since we last met",
          subLabel: "Since we last met",
          value: "addSinceLastMet",
          enabled: true

        },
        {
          label: "Candidate Criteria",
          subLabel: "Candidate Criteria",
          value: "addCandidateCriteria",
          enabled: true

        },
        {
          label: "Market Findings",
          subLabel: "Market Findings",
          value: "marketFindingsPage",
          enabled: true

        },
        {
          label: "Shortlisted Candidates",
          subLabel: "Shortlisted Candidates",
          value: "candidateListPage",
          enabled: true

        },
        {
          label: "Candidate Summary",
          subLabel: "Candidate Summary",
          value: "addCandidateSummary",
          enabled: true,
          children: [
            {
              label: "Career Summary",
              subLabel: "Career Summary",
              value: "addCareerSummary",
              enabled: true
            },
            {
              label: "Assessment Overview ",
              subLabel: "Assessment Overview ",
              value: "candidateInOwnPerspective",
              enabled: true
            },
            // { label: "Agency Perspective", value: "addAgencyPerspective", enabled: true },
            // { subLabel: "Agency Perspective", value: "addAgencyPerspective", enabled: true },
            {
              label: "Advanced Biography",
              subLabel: "Advanced Biography",
              value: "candidateSocialSummary",
              enabled: true
            },

          ]
        },
        {
          label: "Next Steps",
          subLabel: "Next Steps",
          value: "addNextSteps",
          enabled: true

        },
      ]
    },
    enabled: true
  },

  {
    stepName: "addPrivacyStatement",
    label: "Privacy statement",
    settings: {},
    enabled: true
  },
  // {
  //   stepName: "addContent",
  //   label: "Content",
  //   settings: {
  //     mainHeading: "Content",
  //     // details: [
  //     //   {
  //     //     subHeading: "",
  //     //     description: ""
  //     //   }
  //     // ]
  //   },
  //   enabled: true
  // },
  {
    stepName: "addBriefInEssence",
    label: "Brief in essence",
    settings: {},
    enabled: true
  },
  {
    stepName: "addSinceLastMet",
    label: "Since we last met",
    settings: {},
    enabled: true
  },
  {
    stepName: "addCandidateCriteria",
    label: "Candidate Criteria",
    settings: {},
    enabled: true
  },
  {
    stepName: "marketFindingsPage",
    label: "Market Findings",
    settings: {},
    enabled: true
  },
  {
    stepName: "candidateListPage",
    label: "Candidate List",
    settings: {
      mainHeading: "Profiles"
    },
    subSteps: [
      {
        stepName: "editCandidateBasicDetails",
        label: "Edit Candidate",
        settings: {},
        enabled: true
      },
      {
        stepName: "addCareerSummary",
        label: "Career Summary",
        settings: [
          // { label: "Education", value: "education", enabled: true },
          // { label: "Summary", value: "bio", enabled: true },
          { label: "LinkedIn Profile", value: "linkedin_url", enabled: true },
          { label: "Job Description", value: "work_description", enabled: true },
          // { label: "License & Certifications", value: "licenses", enabled: true },
          // { label: "Skills", value: "skills", enabled: true },
        ],
        enabled: true
      },
      // {
      //   stepName: "addAgencyPerspective",
      //   label: "Agency Perspective on Candidate",
      //   settings: {
      //     mainHeading: "",
      //     subHeading: "",
      //     description: [],
      //   },
      //   enabled: true
      // },
      {
        stepName: "candidateInOwnPerspective",
        label: "Assessment Overview",
        settings: {
          mainHeading: "",
          subHeading: "",
          description: [],
        },
        enabled: true
      },
      {
        stepName: "candidateSocialSummary",
        label: "Advanced Biography",
        settings: {
          mainHeading: "",
          subHeading: "",
          description: [],
        },
        enabled: true
      },


    ],
    enabled: true

  },
  {
    stepName: "addNextSteps",
    label: "Next Steps",
    settings: {},
    enabled: true
  },
  {
    stepName: "designs",
    label: "Select Design",
    settings: {
      layout: {
        isLandscape: true
      },
      colors: {
        mainHeading: "#1F2937",
        subHeading: "#1F2937",
        bodyText: "#1F2937",
        accentColor: "#1F2937",
        backgroundColor: "#1F2937",
      },
      fontSizes: {
        mainHeading: 36,
        subHeading: 24,
        bodyText: 20,
      },
      fontFamily: "'Inter', sans-serif",
    },
    enabled: false
  },
];

const initialData = {
  addPrivacyStatement: {
    mainHeading: "Privacy statement",
    details: [
      {
        subHeading: "",
        description: ""
      }
    ]
  },
  // {
  //   stepName: "introPage",
  //   label: "Slide Content",
  //   settings: {
  //     partnerLogo: null,
  //     reportTitle: null,
  //     clientLogo: null,
  //     date: null,
  //     footerText: null,
  //     preparedBy: null,
  //   },
  //   enabled: true
  // },
  introPage: {
    mainHeading: "Slide Content",
    partnerLogo: null,
    reportTitle: null,
    clientLogo: null,
    date: null,
    footerText: null,
    preparedBy: null,
  },
  addBriefInEssence: {
    mainHeading: "Brief in essence",
    details: [
      {
        subHeading: "",
        description: ""
      }
    ]
  },
  addSinceLastMet: {
    mainHeading: "Since we last met",
    details: [
      {
        subHeading: "",
        description: ""
      }
    ]
  },
  addCandidateCriteria: {
    mainHeading: "Candidate Criteria",
    details: [
      {
        subHeading: "",
        description: ""
      }
    ]
  },
  marketFindingsPage: {
    mainHeading: "Market Findings",
    details: [
      {
        subHeading: "",
        description: ""
      }
    ]
  },
  candidateListSettings: {
    mainHeading: "Candidate List Settings",
    details: {
      candidateOrder: [],
      selectedCandidates: []
    }
  },
  addNextSteps: {
    mainHeading: "Next Steps",
    details: [
      {
        subHeading: "",
        description: ""
      }
    ]
  },

};
const initialReportState: ReportState = {
  report_candidates: [],
  selectedCandidate: null,
  selected_candidate: null,
  template: initialTemplate,
  subStepName: null,
  reportData: initialReportData,
  data: initialData,
  actions_allowed: {}
};

export const getCompanyInfo = (state: ReportState) => {
  // Get company name from template
  const companyStep = state.template.find(
    (step: any) => step.stepName === "uploadCompanyDetails"
  );
  const { logo_image_url, job_data } = state.reportData;
  const companyName = companyStep?.settings?.companyName || job_data.recruiting_company || "";

  // Get URLs from reportData


  return {
    companyName,
    logoUrl: logo_image_url || job_data.company_image || "",
  };
};

const reportSlice = createSlice({
  name: "report",
  initialState: initialReportState,
  reducers: {
    // setReportCandidates(state, action: PayloadAction<any>) {
    //   state.report_candidates = action.payload;
    // },
    setReportCandidates(state, action: PayloadAction<any>) {
      state.report_candidates = action.payload;

      // Initialize candidate order when candidates are first set
      const candidates = action.payload;
      if (candidates && candidates.length > 0) {
        const candidateOrder = candidates.map((candidate: any) =>
          candidate.id || candidate.candidate_id || candidate.candidate?.id
        ).filter((id: any) => id);

        if (!state.data.candidateListSettings) {
          state.data.candidateListSettings = {
            mainHeading: "Candidate List Settings",
            details: {
              candidateOrder: candidateOrder,
              selectedCandidates: candidateOrder
            }
          };
        } else if (!state.data.candidateListSettings.details.candidateOrder ||
          state.data.candidateListSettings.details.candidateOrder.length === 0) {
          state.data.candidateListSettings.details.candidateOrder = candidateOrder;
          state.data.candidateListSettings.details.selectedCandidates = candidateOrder;
        }
      }
    },
    setSelectedCandidate(state, action: PayloadAction<any>) {
      state.selectedCandidate = action.payload;
    },
    setSelectedReportCandidate(state, action: PayloadAction<any>) {
      state.selected_candidate = action.payload;
    },
    setReportTemplate(state, action: PayloadAction<any>) {
      state.template = action.payload;
    },
    setCompanyName: (state, action: PayloadAction<string>) => {
      const uploadCompanyDetailsStep = state.template.find(
        (step: any) => step.stepName === "uploadCompanyDetails"
      );
      if (uploadCompanyDetailsStep) {
        uploadCompanyDetailsStep.settings.companyName = action.payload;
      }
    },
    resetReportTemplate(state) {
      state.template = initialTemplate;
    },
    setSubStepName(state, action: PayloadAction<string | null>) {
      state.subStepName = action.payload;
    },
    setReportData(state, action: PayloadAction<any>) {
      const incomingData = action.payload;

      // Apply default values if logo_image_url or cover_image_url are null
      state.reportData = {
        ...initialReportData, // Start with initial defaults
        ...incomingData, // Override with incoming data
        // Ensure specific defaults if null
        logo_image_url: incomingData.logo_image_url || initialReportData.logo_image_url,
        cover_image_url: incomingData.cover_image_url || initialReportData.cover_image_url,
      };
    },

    setActionsAllowed(state, action: PayloadAction<any>) {
      state.actions_allowed = action.payload;
    },
    setReportDataField(state, action: PayloadAction<Partial<ReportData>>) {
      const updates = action.payload;

      // Apply updates with default checks for logo and cover URLs
      state.reportData = {
        ...state.reportData,
        ...updates,
        // Ensure defaults if setting to null
        logo_image_url: updates.logo_image_url !== undefined
          ? (updates.logo_image_url || initialReportData.logo_image_url)
          : state.reportData.logo_image_url,
        cover_image_url: updates.cover_image_url !== undefined
          ? (updates.cover_image_url || initialReportData.cover_image_url)
          : state.reportData.cover_image_url,
      };
    },
    setData(state, action: PayloadAction<Partial<any>>) {
      state.data = action.payload;
    },
    setDataField(
      state,
      action: PayloadAction<{
        stepName: string;
        key: string;
        value: any;
        subKey?: string;
        index?: number;
      }>
    ) {
      const { stepName, key, value, subKey, index } = action.payload;

      const stepData = state.data[stepName] || {};

      if (key === "details" && typeof index === "number" && subKey) {
        const updatedDetails = [...(stepData.details || [])];
        updatedDetails[index] = {
          ...updatedDetails[index],
          [subKey]: value,
        };
        state.data[stepName] = {
          ...stepData,
          details: updatedDetails,
        };
      } else {
        state.data[stepName] = {
          ...stepData,
          [key]: value,
        };
      }
    },
    addDataDetailRow(state, action: PayloadAction<string>) {
      const stepName = action.payload;
      const stepData = state.data[stepName] || {};
      const details = stepData.details || [];

      state.data[stepName] = {
        ...stepData,
        details: [...details, { subHeading: "", description: "" }],
      };
    },
    deleteDataDetailRow(
      state,
      action: PayloadAction<{ stepName: string; index: number }>
    ) {
      const { stepName, index } = action.payload;
      const stepData = state.data[stepName] || {};
      const details = stepData.details || [];

      const updatedDetails = details.filter((_: any, i: number) => i !== index);

      state.data[stepName] = {
        ...stepData,
        details: updatedDetails,
      };
    },
    resetEntireReportState() {
      return initialReportState;
    },
    // In your reports.slice.ts
    // Reorder candidates and save order to candidateListSettings
    reorderReportCandidates: (state, action: PayloadAction<{ fromIndex: number, toIndex: number }>) => {
      const { fromIndex, toIndex } = action.payload;

      // Create a deep copy of the candidates array
      const candidates = [...state.report_candidates];

      // Ensure indices are valid
      if (fromIndex < 0 || fromIndex >= candidates.length ||
        toIndex < 0 || toIndex >= candidates.length) {
        return;
      }

      // Remove the item from its original position
      const [removed] = candidates.splice(fromIndex, 1);
      // Insert it at the new position
      candidates.splice(toIndex, 0, removed);

      // Update the state
      state.report_candidates = candidates;

      // Get candidate IDs in the new order
      const candidateOrder = candidates.map(candidate =>
        candidate.id || candidate.candidate_id || candidate.candidate?.id
      ).filter(id => id);

      // Update candidateListSettings with the new order
      if (state.data.candidateListSettings) {
        state.data.candidateListSettings.details.candidateOrder = candidateOrder;
      } else {
        state.data.candidateListSettings = {
          mainHeading: "Candidate List Settings",
          details: {
            candidateOrder: candidateOrder,
            selectedCandidates: []
          }
        };
      }
    },
    // Toggle candidate selection
    toggleCandidateSelection: (state, action: PayloadAction<{ candidateId: string | number, isSelected: boolean }>) => {
      const { candidateId, isSelected } = action.payload;

      // Initialize candidateListSettings if it doesn't exist
      if (!state.data.candidateListSettings) {
        // Get candidate order from current candidates
        const candidateOrder = state.report_candidates.map((candidate: any) =>
          candidate.id || candidate.candidate_id || candidate.candidate?.id
        ).filter((id: any) => id);

        state.data.candidateListSettings = {
          mainHeading: "Candidate List Settings",
          details: {
            candidateOrder: candidateOrder,
            selectedCandidates: []
          }
        };
      }

      const currentSettings = state.data.candidateListSettings;
      const selectedCandidates = [...(currentSettings.details.selectedCandidates || [])];

      if (isSelected) {
        // Add candidate if not already in the array
        if (!selectedCandidates.includes(candidateId)) {
          selectedCandidates.push(candidateId);
        }
      } else {
        // Remove candidate
        const index = selectedCandidates.indexOf(candidateId);
        if (index > -1) {
          selectedCandidates.splice(index, 1);
        }
      }

      state.data.candidateListSettings.details.selectedCandidates = selectedCandidates;
    },
    // Initialize candidate order
    initializeCandidateOrder: (state) => {
      const candidates = state.report_candidates;

      if (candidates && candidates.length > 0) {
        const candidateOrder = candidates.map((candidate: any) =>
          candidate.id || candidate.candidate_id || candidate.candidate?.id
        ).filter((id: any) => id);

        if (!state.data.candidateListSettings) {
          state.data.candidateListSettings = {
            mainHeading: "Candidate List Settings",
            details: {
              candidateOrder: candidateOrder,
              selectedCandidates: []
            }
          };
        } else if (!state.data.candidateListSettings.details.candidateOrder ||
          state.data.candidateListSettings.details.candidateOrder.length === 0) {
          state.data.candidateListSettings.details.candidateOrder = candidateOrder;
        }
      }
    },

  }
});

export const {
  setReportCandidates,
  setSelectedCandidate,
  setSelectedReportCandidate,
  setReportTemplate,
  resetReportTemplate,
  setSubStepName,
  setReportData,
  setActionsAllowed,
  setReportDataField,
  setCompanyName,
  resetEntireReportState,
  setData,
  deleteDataDetailRow,
  setDataField,
  addDataDetailRow,
  reorderReportCandidates,
  toggleCandidateSelection
} = reportSlice.actions;

export default reportSlice.reducer;
